import { graphql } from "react-relay";

export const IHK_CERTIFICATE_REWARD_BUNDLE_FRAGMENT = graphql`
	fragment ihkCertificateRewardBundleForm_IHKCertificateRewardBundleFragment on IHKCertificateBundle {
		id
		bundleIds
	}
`;

export const EDIT_IHK_CERTIFICATE_REWARD_BUNDLE_MUTATION = graphql`
	mutation ihkCertificateRewardBundleForm_EditIHKCertificateRewardBundleMutation(
		$input: EditIHKCertificateBundleRewardInput!
	) {
		Admin {
			Tree {
				editIHKCertificateBundleReward(input: $input) {
					content {
						...rewardEditor_TreeNodeFragment
					}
				}
			}
		}
	}
`;
